/* Maison Byōbu · vitesse de la fiche œuvre (03/11/2026, audit vitesse).
   L'image HD de l'œuvre utilisée par le cadreur (3 200 px, jusqu'à 1,4 Mo) partait dès l'ouverture de la fiche, en même
   temps que la photo principale, alors que le cadreur est en bas de page : sur téléphone, elle ralentissait l'affichage
   du premier écran. Elle part maintenant quand le cadreur approche de l'écran (1 500 px avant), au premier geste dans le
   cadreur, ou 3 s après le chargement complet de la page (si une étape s'ouvre avant, son fond est complété à ce moment-là). Même fichier, même rendu : seul le moment du téléchargement change.
   Motifs à raccord (toile de Jouy…) : la tuile est le même fichier HD (jusqu'à 1,9 Mo) ; elle suit la même règle (03/11, v2).
   Chargé dans le head (snippets/mb-bandeau-colle.liquid), donc avant assets/mb-cadreur.js.
   Retour arrière : retirer la ligne mb-vitesse.js de snippets/mb-bandeau-colle.liquid. */
(function () {
  'use strict';
  if (!window.customElements || !('IntersectionObserver' in window)) return;
  var VIDE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  function differer(el, vraie) {
    var fait = false, io = null;
    var gestes = ['pointerdown', 'focusin', 'click', 'touchstart'];
    function charger() {
      if (fait) return;
      fait = true;
      if (io) io.disconnect();
      gestes.forEach(function (g) { el.removeEventListener(g, charger, true); });
      if (el.mbTuile) el.dataset.tuile = el.mbTuile;
      var repete = el.dataset.repete === 'oui';
      if (repete && !el.raccord) return; /* motif sans tuile : mb-v2-cadreur.js n'affiche rien */
      var url = 'url("' + (repete && el.mbTuile ? el.mbTuile : vraie) + '")';
      el.urlMur = url;
      ((el.el && el.el.cartes) || []).forEach(function (c) { c.style.setProperty('--mb-carte-img', url); });
      el.querySelectorAll('[style]').forEach(function (n) {
        if (n.style.backgroundImage && n.style.backgroundImage.indexOf('data:image/gif') !== -1) n.style.backgroundImage = url;
      });
      try { if (el.gL && typeof el.fondMur === 'function') el.fondMur(); } catch (e) {}
    }
    gestes.forEach(function (g) { el.addEventListener(g, charger, { capture: true, passive: true }); });
    /* Une boîte vide (étape pas encore ouverte, 0 × 0 px) compte comme « visible » pour IntersectionObserver : on l'ignore. */
    io = new IntersectionObserver(function (entrees) {
      for (var i = 0; i < entrees.length; i++) {
        var e = entrees[i], b = e.boundingClientRect;
        if (e.isIntersecting && b.width > 0 && b.height > 0) { charger(); return; }
      }
    }, { rootMargin: '1500px 0px 1500px 0px' });
    io.observe(el);
    el.querySelectorAll('.mb-cadreur__mur').forEach(function (n) { io.observe(n); });
    var apres = function () { setTimeout(charger, 3000); };
    if (document.readyState === 'complete') apres(); else window.addEventListener('load', apres, { once: true });
  }

  function patcher(C) {
    var P = C && C.prototype;
    if (!P || P.mbVitesse || typeof P.connectedCallback !== 'function') return;
    P.mbVitesse = true;
    var cc = P.connectedCallback;
    P.connectedCallback = function () {
      var vraie = this.dataset.image;
      if (this.pret || !vraie || /^data:/.test(vraie)) return cc.apply(this, arguments);
      /* La tuile n'est lue que par mb-v2-cadreur.js, qui s'exécute après : elle reste vide jusqu'au chargement. */
      var tuile = this.dataset.tuile;
      if (tuile && !/^data:/.test(tuile)) { this.mbTuile = tuile; this.dataset.tuile = VIDE; }
      this.dataset.image = VIDE;
      try {
        return cc.apply(this, arguments);
      } finally {
        this.dataset.image = vraie;
        differer(this, vraie);
      }
    };
  }

  if (customElements.get('mb-cadreur')) return; /* déjà défini : on ne touche à rien */
  var definir = customElements.define;
  customElements.define = function (nom, C) {
    if (nom === 'mb-cadreur') { try { patcher(C); } catch (e) {} }
    return definir.apply(this, arguments);
  };
})();
